/* eslint-disable no-unused-vars */
import { createContext, useState, useEffect } from "react";
import { signInWithEmailAndPassword, onAuthStateChanged, sendPasswordResetEmail } from "firebase/auth"
import { auth, db, functions } from "../firebase"
import { collection, getDocs, query, where } from "firebase/firestore";
import { useCookies } from "react-cookie";


export const UserContext = createContext()

export function UserContextProvider(props) {

  const [currentUser, setCurrentUser] = useState();
  const [loadingData, setLoadingData] = useState(true);
  const [currentUserState, setCurrentUserState] = useState(0)
  const [cookie, setCookie, removeCookie] = useCookies(['whatson'], "/");
  const [searchQuery, setSearchQuery] = useState()

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      console.log("current User:" + currentUser)
      setCurrentUser(currentUser)
      if(currentUser !== undefined){
        if(currentUser !== null){
          getUserByEmail(currentUser.email).then(response => {
            console.log(response)
            if(response.role !== undefined){
              setCurrentUserState(response.role)
            }
            else{
              setCurrentUserState(0)
            }
          })
        }
      }
      console.log(currentUserState)
      setLoadingData(false)
    })
    return unsubscribe;
  }, [currentUserState])


  const getCustomerOrdersBySource = async (source) => {
    var ordersList = []
    const ordersRef = collection(db,"customerOrders")
    const q = await query(ordersRef, where("source", "==", source))
    const querySnapshot = await getDocs(q)
    querySnapshot.forEach((doc) => {
      var user = { id: doc.id, ...doc.data() }
      ordersList.push(user)
    })
    return ordersList
  }

  const getUserByEmail = async (email) => {
    var usersList = []
    var lowerEmail = email.toLowerCase();
    const userRef = collection(db, "users")
    const q = await query(userRef, where("email", "==", lowerEmail));
    const querySnapshot = await getDocs(q)
    querySnapshot.forEach((doc) => {
      var user = { id: doc.id, ...doc.data() }
      usersList.push(user)
    })
    return usersList[0]
  }

  const resetPassword = async (email) => {
    await sendPasswordResetEmail(auth, email)
  }

  const initiateSearchQuery = (data) => {
    var stripped = data.replace(" ","")
    console.log(stripped)
    setSearchQuery(stripped)
  }

  // const signUp = async (email, pwd, displayName, role, retailerName, retailerAddressLine1, retailerAddressLine2, retailerTown, retailerCity, retailerPostcode, retailerPhoneNumber) => {
  //   await createUserWithEmailAndPassword(auth, email, pwd).then((res) => {
  //     updateProfile(auth.currentUser, {
  //       displayName: displayName
  //     }).then(() => {
  //       if (role !== "6" && role !== "7") {


  //         var data = {
  //           displayName: displayName,
  //           email: email,
  //           role: role,
  //           uid: auth.currentUser.uid
  //         }
  //       }
  //       else {
  //         data = {
  //           displayName: displayName,
  //           email: email,
  //           role: role,
  //           uid: auth.currentUser.uid,
  //           retailerName: retailerName,
  //           retailerAddressLine1: retailerAddressLine1,
  //           retailerAddressLine2: retailerAddressLine2,
  //           retailerTown: retailerTown,
  //           retailerCity: retailerCity,
  //           retailerPostcode: retailerPostcode,
  //           retailerPhoneNumber: retailerPhoneNumber
  //         }
  //       }
  //       addDoc(collection(db, "users"), data);
  //     })
  //   })
  // }
  const signIn = (email, pwd) => signInWithEmailAndPassword(auth, email, pwd)

  const getUserList = async () => {
    var userList = []
    const querySnapshot = await getDocs(collection(db, "users"));
    querySnapshot.forEach((doc) => {
      var item = { id: doc.id, ...doc.data() }
      userList.push(item)
    });

    return userList
  }

  const getUserByUid = async (id) => {
    var userList = []
    const userRef = collection(db, "users");
    const q = await query(userRef, where("uid", "==", id))
    const querySnapshot = await getDocs(q)
    querySnapshot.forEach((doc) => {
      var item = { id: doc.id, ...doc.data() }
      userList.push(item)
    });
    return userList
  }

 

  // modal
  const [modalState, setModalState] = useState({
    signUpModal: false,
    signInModal: false
  })

  const toggleModals = modal => {
    if (modal === "signIn") {
      setModalState({
        signUpModal: false,
        signInModal: true
      })
    }
    if (modal === "signUp") {
      setModalState({
        signUpModal: true,
        signInModal: false
      })
    }
    if (modal === "close") {
      setModalState({
        signUpModal: false,
        signInModal: false
      })
    }
  }

  const setCurrentUserRole = (role) => {
    if(typeof(role) == "undefined"){
      setCurrentUserRole(0)
    }
    else{
      setCurrentUserState(role)
    }
  }

  return (
    <UserContext.Provider value={{
      modalState, toggleModals, setCurrentUserRole, currentUserState, currentUser, signIn, getUserList, resetPassword, functions, getUserByUid, getUserByEmail, getCustomerOrdersBySource, initiateSearchQuery, searchQuery
    }}>
      {!loadingData && props.children}
    </UserContext.Provider>
  )
}

